export default "__VITE_ASSET__Bvx8yCrK__"